import React, { useEffect, useState } from 'react';
import classnames from 'classnames';

import classes from './MixAndMatchProductPicker.scss';

type Props = {
    disabled?: boolean;
    handleBundleQuantityChange: (quantity: number, index: number, productIndex: number) => void;
    productIndex: number;
    index: number;
    newOptionPicked?: string | undefined;
    maxQty: number;
};

export const MixAndMatchNumberInput: React.FC<Props> = ({
    disabled,
    handleBundleQuantityChange,
    productIndex,
    index,
    newOptionPicked,
    maxQty,
}) => {
    const [value, setValue] = useState<number>(0);

    useEffect(() => {
        if (newOptionPicked) {
            setValue(0);
        }
    }, [newOptionPicked]);

    const onIncreaseQty = () => {
        if (!disabled && value + 1 <= maxQty) {
            setValue(value + 1);
            handleBundleQuantityChange(value + 1, index, productIndex);
        }
    };

    const onDecreaseQty = () => {
        if (!disabled && value > 0) {
            setValue(value - 1);
            handleBundleQuantityChange(value - 1, index, productIndex);
        }
    };

    const onInput = (event) => {
        if (Boolean(event.target.value) === false) {
            setValue(0);
            handleBundleQuantityChange(0, index, productIndex);
        }

        if (Boolean(event.target.value) === true) {
            const value = parseInt(event.target.value) <= maxQty ? parseInt(event.target.value) : maxQty;
            setValue(value || 0);
            handleBundleQuantityChange(value || 0, index, productIndex);
        }
    };

    return (
        <div
            className={classnames(classes.tableCell, classes.tableInput, {
                [classes.disabledTableCell]: disabled,
            })}
        >
            <input
                type="number"
                min="0"
                value={value}
                className={classnames(classes.numberInput, {
                    [classes.numberInputActive]: value > 0,
                })}
                onInput={onInput}
                disabled={disabled}
                max={maxQty}
            />
            <button type="button" className={classes.numberButtonUp} onClick={() => onIncreaseQty()}>
                <img
                    className={classes.arrowUp}
                    src={require('../../static/icons/MixMatchArrowDown.png')}
                    alt="Arrow Up"
                />
            </button>
            <button type="button" className={classes.numberButtonDown} onClick={() => onDecreaseQty()}>
                <img
                    className={classes.arrowDown}
                    src={require('../../static/icons/MixMatchArrowDown.png')}
                    alt="Arrow Down"
                />
            </button>
        </div>
    );
};
